module.exports = __webpack_public_path__ + "static/media/Oswald-Medium.64cd7cbc.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Oswald-Medium.ttf
// module id = 6697
// module chunks = 2